import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMHRDocumentListModal = (customerID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrDocumentList($customerID: String) {
        mhrDocumentList(customerId: $customerID) {
          result {
            documentId 
            repositoryUniqueId
            name
            organization
            organizationType
            documentType
            creationDate
          }
          ok
          error
        }
      }
    `),
    {
      variables: {
        customerID,
      },
    },
  );

  return {
    ok: !error,
    loading,
    error: error ? 'Error loading document view' : data?.mhrDocumentList?.error,
    result: data?.mhrDocumentList?.result,
  };
};
